import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

const defaultState = {
  numberPad: {
    display: null,
    value: '',
  },
}

export const waiter = handleActions({
  RESET_WAITER_NUMBER_PAD: () => defaultState,

  RESET_WAITER_NUMBER_PAD_VALUE: (state) => {
    return update(state, {
      numberPad: {
        value: { $set: defaultState.numberPad.value },
      },
    })
  },

  UPDATE_DISPLAY_WAITER_NUMBER_PAD: (state, action) => {
    return update(state, {
      numberPad: {
        display: { $set: action.payload.display },
      },
    })
  },

  UPDATE_WAITER_NUMBER_PAD_VALUE: (state, action) => {
    return update(state, {
      numberPad: {
        value: { $set: action.payload.value },
      },
    })
  },
}, defaultState)

export default { waiter }



// WEBPACK FOOTER //
// ./src/reducers/components/waiter.js